"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationSeverity = void 0;
var NotificationSeverity;
(function (NotificationSeverity) {
    NotificationSeverity["ERROR"] = "error";
    NotificationSeverity["WARNING"] = "warning";
    NotificationSeverity["INFO"] = "info";
    NotificationSeverity["SUCCESS"] = "success";
})(NotificationSeverity || (exports.NotificationSeverity = NotificationSeverity = {}));
